import api from './index';

export default {
  register(payload) {
    return api.post('/auth/register', payload);
  },
  login(email, password) {
    return api.post('/auth/login', { email, password });
  },
  logout() {
    return api.post('/auth/logout');
  },
  getMe() {
    return api.get('/auth/me');
  },
  getUsers() {
    return api.get('/auth/users');
  },
  createUser(payload) {
    return api.post('/auth/users', payload);
  },
  updateUser(id, payload) {
    return api.put(`/auth/users/${id}`, payload);
  },
  updateBusinessPlan(planTier) {
    return api.put('/auth/business/plan', { planTier });
  },
  requestGrowthUpgrade() {
    return api.post('/auth/business/upgrade-request');
  },
  getSuperAdminBusinesses() {
    return api.get('/auth/super-admin/businesses');
  },
  updateSuperAdminBusinessPlan(businessId, planTier) {
    return api.put(`/auth/super-admin/businesses/${businessId}/plan`, { planTier });
  },
  updateSuperAdminBusinessFollowup(businessId, needsSalesFollowup) {
    return api.put(`/auth/super-admin/businesses/${businessId}/followup`, { needsSalesFollowup });
  },
  trackPageView(page) {
    return api.post('/auth/analytics/page-view', { page });
  },
  getSuperAdminAnalytics() {
    return api.get('/auth/super-admin/analytics');
  },
  updateBusiness(data) {
    return api.put('/auth/business', data);
  },
  changePassword(currentPassword, newPassword) {
    return api.post('/auth/change-password', { currentPassword, newPassword });
  },
};
